import { useLogger } from '@booksy-com/vue-tools'
import { useAccessLevelPermissions } from '@/composables/access-level-permissions/index'

import { ROUTE_META_PARAMS } from '../consts.js'
const logger = useLogger('router.guard.check-access-level-permission')

export default function (route, from, next) {
  logger.debug(route.path)

  const businessRoute = !!route.matched.find(r => r.name === 'business')

  // shortcut: works only for business (sub-)routes
  if (!businessRoute) {
    return next()
  }

  const permissions = route.matched
    .filter(r => r.meta?.[ROUTE_META_PARAMS.ACCESS_LEVEL_PERMISSION])
    .map(r => r.meta[ROUTE_META_PARAMS.ACCESS_LEVEL_PERMISSION])

  // shortcut: allowed for everyone
  if (!permissions.length) {
    return next()
  }

  const { hasAccess } = useAccessLevelPermissions()

  // shortcut: user can access
  if (permissions.every(permission => { return hasAccess(permission) })) {
    return next()
  }

  logger.debug('redirecting to "forbidden" view...')
  next({
    name: 'forbidden',
    params: { businessId: route.params.businessId },
    query: { reason: 'no-access' }, // xxx
  })
}
